import auth from "@/auth/index"
let routes = [
  {
    path: '',
    component: resolve => require(['@/views/layout/Layout'], resolve),
    children: [
      {
        path: '/blockChain',
        name: 'blockChain',
        component: resolve => require(['@/views/blockchain/index'], resolve),
        meta: {
          title: '区块链管理',
          breadLevel: 0,
          icon: 'icon-chain',
          auth: auth.blockchain
        }
      },
      {
        path: '/blockChain/addChain',
        name: 'addChain',
        component: resolve => require(['@/views/blockchain/createChain'], resolve),
        meta: {
          title: '新建区块链',
          breadLevel: 1
        }
      },
      {
        path: '/blockChain/chainDetail',
        name: 'chainDetail',
        component: resolve => require(['@/views/blockchain/chainDetail'], resolve),
        meta: {
          title: '区块链详情',
          breadLevel: 1
        }
      },
      {
        path: '/blockChain/chainDetail/channel',
        name: 'channel',
        component: resolve =>
          require(['@/views/blockchain/expansionNode/channelList.vue'], resolve),
        meta: {
          title: '通道管理',
          breadLevel: 2
        }
      },
      {
        path: '/blockChain/chainDetail/archivingDetail',
        name: 'archivingDetail',
        component: resolve =>
          require(['@/views/blockchain/dataArchiving/archivingDetail'], resolve),
        meta: {
          title: '归档详情',
          breadLevel: 2
        }
      },
      {
        path: '/blockChain/chainDetail/archivingTxnDetail',
        name: 'archivingTxnDetail',
        component: resolve =>
          require(['@/views/blockchain/dataArchiving/archivingTxnDetail'], resolve),
        meta: {
          title: '归档交易详情',
          breadLevel: 2
        }
      }
    ]
  }
]

export default routes
